export default __webpack_public_path__ + "static/media/6.d6602dcd.jpeg";